function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genFormDateRangeStyle = function genFormDateRangeStyle(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty(_defineProperty(_defineProperty({
    // 标题
    color: 'rgba(0, 0, 0, 0.45)',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '22px',
    paddingBottom: '16px'
  }, "&-label", {
    paddingBottom: '4px'
  }), "&-content", {
    display: 'flex',
    alignItems: 'center'
  }), "&-delimiter", {
    padding: '0 8px'
  }))];
};